import React from 'react'
import { useVocabulary } from '../context/vocabulary'
import { CountryType } from '../models'
import {
  LookupItemPicker,
  LookupItemPickerUserPropsType,
} from './LookupItemPicker'

type CountryPickerPropsType = LookupItemPickerUserPropsType

export const CountryPicker = (props: CountryPickerPropsType) => {
  const { vocabulary } = useVocabulary()

  const allCountries: CountryType[] = vocabulary.countries

  return <LookupItemPicker {...props} lookupItems={allCountries} />
}
